import { HistoricoDto } from '@/api.types';
import { ehAlteracaoSomenteAuditoria, jsonDetalheHistorico, rotuloTabela } from '@/modules/system/historico/historico-detalhe.utils';
import { IconeAcao } from '@/modules/system/historico/historico-icones';
import { GetHistoricoUsuario } from '@/modules/system/historico/historico.service';
import { format } from 'date-fns';
import { ptBR } from 'date-fns/locale/pt-BR';
import { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';

interface ModalDetalheHistoricoProps {
  item: HistoricoDto | null;
  show: boolean;
  onHide: () => void;
}

function dataLinha(valor: string | Date) {
  return format(new Date(valor), "EEEE dd/MM/yyyy 'às' HH:mm", { locale: ptBR });
}

function CardLog({ log }: { log: HistoricoDto }) {
  const json = jsonDetalheHistorico(log.diff as Record<string, unknown> | null);

  return (
    <div className="border rounded p-3 mb-2">
      <div className="d-flex justify-content-between align-items-center gap-3 mb-2">
        <span className="d-inline-flex align-items-center gap-2">
          <IconeAcao acao={log.acao} />
          <span>{log.criadoPor?.username}</span>
        </span>
        <span className="text-muted text-nowrap small">{dataLinha(log.criadoEm)}</span>
      </div>
      {log.acao === 'DELETE' && !json ? (
        <p className="mb-0">O registro foi removido.</p>
      ) : json ? (
        <pre className="border rounded p-2 mb-0 bg-light small" style={{ whiteSpace: 'pre-wrap' }}>
          {json}
        </pre>
      ) : (
        <p className="mb-0">Nenhum campo detalhado.</p>
      )}
    </div>
  );
}

export default function ModalDetalheHistorico({ item, show, onHide }: ModalDetalheHistoricoProps) {
  const [logs, setLogs] = useState<HistoricoDto[]>([]);
  const [ocultarLogin, setOcultarLogin] = useState(true);
  const ehUsuario = item?.tabela === 'usuario';

  useEffect(() => {
    setOcultarLogin(true);
  }, [show, item]);

  useEffect(() => {
    if (!show || !item?.tabela || item.registro == null || item.registro === '') {
      setLogs([]);
      return;
    }

    let ativo = true;
    setLogs([item]);
    GetHistoricoUsuario({
      tabela: item.tabela,
      registro: String(item.registro),
      data_inicial: '2000-01-01',
      data_final: '3000-01-01',
      skip: 0,
      take: 5000,
      orderBy: 'DESC',
      orderField: 'criadoEm',
      incluir_auditoria: true,
    })
      .then(([lista]) => {
        if (ativo && lista.length > 0) setLogs(lista);
      })
      .catch(() => {
        if (ativo) setLogs([item]);
      });

    return () => {
      ativo = false;
    };
  }, [show, item]);

  const visiveis = ehUsuario && ocultarLogin
    ? logs.filter((log) => !ehAlteracaoSomenteAuditoria(log.diff))
    : logs;

  return (
    <Modal show={show} onHide={onHide} size="lg" centered scrollable>
      <Modal.Header closeButton>
        <Modal.Title>
          Log do Registro - {item?.registro} - {item ? rotuloTabela(item.tabela) : ''}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {ehUsuario && (
          <div className="form-check mb-3">
            <input
              className="form-check-input"
              type="checkbox"
              id="ocultar-alteracoes-login"
              checked={ocultarLogin}
              onChange={(e) => setOcultarLogin(e.target.checked)}
            />
            <label className="form-check-label" htmlFor="ocultar-alteracoes-login">
              Ocultar alterações de login
            </label>
          </div>
        )}
        {visiveis.map((log, indice) => (
          <CardLog key={`${log.criadoEm}-${indice}`} log={log} />
        ))}
      </Modal.Body>
    </Modal>
  );
}
